import React, { useEffect, useState } from 'react';

const ScrollProgress = ({ targetSelector = '#blog-content' }) => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const contentEl = document.querySelector(targetSelector);
            if (!contentEl) return;

            const totalHeight = contentEl.scrollHeight || contentEl.offsetHeight;
            const scrollTop = window.scrollY;
            const offsetTop = contentEl.offsetTop;
            const scrollPosition = scrollTop - offsetTop;

            const percent = Math.min(
                100,
                Math.max(0, (scrollPosition / (totalHeight - window.innerHeight)) * 100)
            );

            setProgress(Math.round(percent));
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Initial call

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [targetSelector]);

    return (
        <div className="scroll-progress-widget">
            <div className="scroll-percent">
                <strong>{progress}%</strong>
            </div>
            <div className="progress-bar-container">
                <div className="progress-bar" style={{ width: `${progress}%` }} />
            </div>
        </div>
    );
};

export default ScrollProgress;
